import { render, staticRenderFns } from "./TeamRequestDetail.vue?vue&type=template&id=6711afe7&scoped=true"
import script from "./teamRequestDetail.ts?vue&type=script&lang=ts&external"
export * from "./teamRequestDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequestDetail.vue?vue&type=style&index=0&id=6711afe7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711afe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6711afe7')) {
      api.createRecord('6711afe7', component.options)
    } else {
      api.reload('6711afe7', component.options)
    }
    module.hot.accept("./TeamRequestDetail.vue?vue&type=template&id=6711afe7&scoped=true", function () {
      api.rerender('6711afe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/team-request-detail/TeamRequestDetail.vue"
export default component.exports